// import React from "react";
// //Material UI Imports
// import {
//   // Box,
//   // Button,
//   // ListItemIcon,
//   // MenuItem,
//   // Typography,
//   // lighten,
// } from "@mui/material";
// import {
//   MaterialReactTable,
//   // MRT_GlobalFilterTextField,
//   // MRT_ToggleFiltersButton,
//   useMaterialReactTable,
// } from "material-react-table";

// // import PropTypes from "prop-types";

// //Icons Imports
// // import { AccountCircle, Send } from "@mui/icons-material";

// // CommonMaterialReactTable.propTypes = {
// //   columns: PropTypes.array,
// //   data: PropTypes.array,
// // };

// function CommonMaterialReactTable({ columns, data, columnRightPin=[] }) {
//   console.log(columns, "columns MaterialReactTable");
//   console.log(data, "data MaterialReactTable");

//   const table = useMaterialReactTable({
//     columns,
//     data,
//     enableColumnFilterModes: true,
//     enableColumnOrdering: true,
//     enableGrouping: false,
//     enableColumnPinning: true,
//     enableFacetedValues: true,
//     enableRowActions: false,
//     enableRowSelection: false,
//     enableColumnResizing: true,
//     initialState: {
//       showColumnFilters: false,
//       showGlobalFilter: true,
//       pagination: { pageSize: 50, pageIndex: 0 },
//       columnPinning: {
//         // left: ["mrt-row-expand", "mrt-row-select"],
//         right: columnRightPin,
//       },
//     },
//     positionPagination:"bottom",
//     columnResizeMode:"onEnd",
//     // paginationDisplayMode: "pages", 
//     positionToolbarAlertBanner: "top",
//     positionGlobalFilter: "left",

//     muiSearchTextFieldProps: {
//       size: "small",
//       variant: "outlined",
//     },
//     muiPaginationProps: {
//       color: "secondary",
//       rowsPerPageOptions: [10,50, 100, 300, 500, 1000, 1500, 2000],
//       shape: "rounded",
//       variant: "outlined",
//     },
//     layoutMode:"grid"
//     // renderDetailPanel: ({ row }) => (
//     //   <Box
//     //     sx={{
//     //       alignItems: "center",
//     //       display: "flex",
//     //       justifyContent: "space-around",
//     //       left: "30px",
//     //       maxWidth: "1000px",
//     //       position: "sticky",
//     //       width: "100%",
//     //     }}
//     //   >
//     //     <img
//     //       alt="avatar"
//     //       height={200}
//     //       src={row.original.avatar}
//     //       loading="lazy"
//     //       style={{ borderRadius: "50%" }}
//     //     />
//     //     <Box sx={{ textAlign: "center" }}>
//     //       <Typography variant="h4">Signature Catch Phrase:</Typography>
//     //       <Typography variant="h1">
//     //         &quot;{row.original.signatureCatchPhrase}&quot;
//     //       </Typography>
//     //     </Box>
//     //   </Box>
//     // ),
//     // renderRowActionMenuItems: ({ closeMenu }) => [
//     //   <MenuItem
//     //     key={0}
//     //     onClick={() => {
//     //       // View profile logic...
//     //       closeMenu();
//     //     }}
//     //     sx={{ m: 0 }}
//     //   >
//     //     <ListItemIcon>
//     //       <AccountCircle />
//     //     </ListItemIcon>
//     //     View Profile
//     //   </MenuItem>,
//     //   <MenuItem
//     //     key={1}
//     //     onClick={() => {
//     //       // Send email logic...
//     //       closeMenu();
//     //     }}
//     //     sx={{ m: 0 }}
//     //   >
//     //     <ListItemIcon>
//     //       <Send />
//     //     </ListItemIcon>
//     //     Send Email
//     //   </MenuItem>,
//     // ],
//     // renderTopToolbar: ({ table }) => {
//     //   const handleDeactivate = () => {
//     //     table.getSelectedRowModel().flatRows.map((row) => {
//     //       alert("deactivating " + row.getValue("name"));
//     //     });
//     //   };

//     //   const handleActivate = () => {
//     //     table.getSelectedRowModel().flatRows.map((row) => {
//     //       alert("activating " + row.getValue("name"));
//     //     });
//     //   };

//     //   const handleContact = () => {
//     //     table.getSelectedRowModel().flatRows.map((row) => {
//     //       alert("contact " + row.getValue("name"));
//     //     });
//     //   };

//     //   return (
//     //     <Box
//     //       sx={() => ({
//     //         backgroundColor: lighten(.palette.background.default, 0.05),
//     //         display: "flex",
//     //         gap: "0.5rem",
//     //         p: "8px",
//     //         justifyContent: "space-between",
//     //       })}
//     //     >
//     //       <Box sx={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
//     //         {/* import MRT sub-components */}
//     //         {/* <MRT_GlobalFilterTextField table={table} />
//     //         <MRT_ToggleFiltersButton table={table} /> */}
//     //       </Box>
//     //       <Box>
//     //         <Box sx={{ display: "flex", gap: "0.5rem" }}>
//     //           <Button
//     //             color="error"
//     //             disabled={!table.getIsSomeRowsSelected()}
//     //             onClick={handleDeactivate}
//     //             variant="contained"
//     //           >
//     //             Deactivate
//     //           </Button>
//     //           <Button
//     //             color="success"
//     //             disabled={!table.getIsSomeRowsSelected()}
//     //             onClick={handleActivate}
//     //             variant="contained"
//     //           >
//     //             Activate
//     //           </Button>
//     //           <Button
//     //             color="info"
//     //             disabled={!table.getIsSomeRowsSelected()}
//     //             onClick={handleContact}
//     //             variant="contained"
//     //           >
//     //             Contact
//     //           </Button>
//     //         </Box>
//     //       </Box>
//     //     </Box>
//     //   );
//     // },
//   });

//   return (
//     <div>
//       <MaterialReactTable table={table} />
//     </div>
//   );
// }

// export default CommonMaterialReactTable;

import React from "react";
import {
} from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

function CommonMaterialReactTable({ columns, data, columnRightPin=[], enableGrouping = false }) {
  console.log(columns, "columns MaterialReactTable");
  console.log(data, "data MaterialReactTable");

  const [columnPinning, setColumnPinning] = React.useState({
    right: window.innerWidth < 768 ? [] : columnRightPin,
  });

  React.useEffect(() => {
    const handleResize = () => {
      setColumnPinning((prev) => ({
        ...prev,
        right: window.innerWidth < 768 ? [] : columnRightPin,
      }));
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [columnRightPin]);

  const table = useMaterialReactTable({
    columns,
    data,
    enableColumnFilterModes: true,
    enableColumnOrdering: true,
    enableGrouping: enableGrouping,
    enableColumnPinning: true,
    enableFacetedValues: true,
    enableRowActions: false,
    enableRowSelection: false,
    enableColumnResizing: true,
    initialState: {
    showColumnFilters: false,
    showGlobalFilter: true,
    pagination: { pageSize: 50, pageIndex: 0 },

    // ✅ apply grouping ONLY when enabled
    grouping: enableGrouping ? ['businessUniqueName'] : [],  
    expanded: enableGrouping,     
  },
    state: {
      columnPinning,
    },
    onColumnPinningChange: setColumnPinning,
    positionPagination:"bottom",
    columnResizeMode:"onEnd",
    positionToolbarAlertBanner: "top",
    positionGlobalFilter: "left",

    muiSearchTextFieldProps: {
      size: "small",
      variant: "outlined",
      placeholder: 'Search all users', sx: { minWidth: '300px', border: '1px solid #ff0000' }
      
    },
    enableFilterMatchHighlighting: false, //disable filter match highlighting
    muiPaginationProps: {
      color: "secondary",
      rowsPerPageOptions: [10,50, 100, 300, 500, 1000, 1500, 2000],
      shape: "rounded",
      variant: "outlined",
    },
    layoutMode:"grid",
    muiTableHeadCellProps:{
      sx: {
        backgroundColor: "#f8f9fa",
        borderRight: "1px solid #dee2e6",
        lineHeight: "16px",
        fontWeight: 600,
        fontSize: "13px",
        color: "#212529",
        fontFamily: "Inter, sans-serif",
      },
    },
    muiTableBodyCellProps:{
      sx: {
        fontSize: "14px",
        fontWeight: 500,
        fontFamily: "Inter, sans-serif",
        padding: "8px 16px",
        borderBottom: "1px solid #e9ecef",
        color: "#212529",
      },
    },
    muiTableBodyRowProps:{
      sx: {
        height: "48px",
      },
    },
    muiTablePaperProps:{
      sx: {
        boxShadow: "none",
      },
    },
    muiTableContainerProps:{
      sx: {
        border: "1px solid #dee2e6",
        borderRadius: "6px",
      },
    },
    muiSelectCheckboxProps:{
      sx: {
        padding: "4px",
      },
    },
    muiSelectAllCheckboxProps:{
      sx: {
        padding: "4px",
      },
    },
    muiToolbarAlertBannerProps:{
      sx: {
        background: "#f1f3f5",
        color: "#495057",
        fontSize: "14px",
        fontWeight: 500,
        fontFamily: "Inter, sans-serif",
      },
    }
  });

  return (
    <div>
      <MaterialReactTable table={table} />
    </div>
  );
}

export default CommonMaterialReactTable;
